Vue.component('ack-concierge-service', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-concierge-service',
	mixins: [languageMixins],
	created() {
		this.productPrice();
	},
	mounted() {
		appLog.log('ack-concierge-service mounted');
		this.setPageIsLoading(false);
	},
	props: {},
	computed: {
		...Vuex.mapGetters('localization', [
			'isUS_CA',
			'countryCode',
			'currencySymbol',
			'isLatam',
			'isRestOfWorld',
			'isUsCaAuNzPrIn',
			'isEurope',
			'regions',
		]),
		...Vuex.mapGetters('shop', ['currentCountryCode']),
		conciergePrice() {
			return this.conciergeServicePrice
				? `${this.currencySymbol} ${new this.numeralFormatter(this.conciergeServicePrice).format('0,0.00')}`
				: '';
		},
		isMobile() {
			return this.$parent.isMobile;
		},
		ackurettaConcierge() {
			if (this.isUsCaAuNzPrIn) {
				return this.ackurettaConciergeAmerican;
			} else if (this.isLatam) {
				return this.ackurettaConciergeLatam;
			} else if (this.isEurope) {
				return this.ackurettaConciergeEurope;
			} else {
				return this.ackurettaConciergeWorld;
			}
		},
		extendedConciergePdfLink() {
			return getExtendedConciergePdf(this.regions);
		},
	},
	data() {
		return {
			pageId: 'concierge-service-page',
			numeralFormatter: numeral,
			conciergeServicePrice: null,
			title: 'Ackuretta Concierge',
			headline:
				'<b>Ackuretta Concierge</b> offers premium support for your <b>entire dental 3D printing solution</b>. As developers of the hardware, software, and many materials, our experts provide uparalleed, <b> tailored service</b>. This program includes a <b>2-year extended 3D printer warranty, priority support for all devices, and exclusive learning resources</b>. Our knowledge ensures efficient problem-solving, keeping your practice at the forefront of digital dentistry.',
			features: [
				{
					image:
						window.ackShopifyFileUrl("Concierge_Icon_1_33fb075a-a7b7-41f5-96f9-7972cce5cc92.png"),
					title: 'Extended 3D Printer 2-Year Warranty',
					description:
						'⁠Secure your investment with an extra year of protection. Enjoy 24 months of comprehensive coverage, ensuring peace of mind and uninterrupted printing. Stay focused on innovation, not maintenance worries.',
				},
				{
					image:
						window.ackShopifyFileUrl("Concierge_Icon_4_edc6fff2-c806-413c-8634-b534874b5204.png"),
					title: 'Priority Support Access',
					description:
						'⁠Skip the queue with our fast-track support system. Connect with 3D printing experts in as little as two hours. Experience swift, personalized solutions that keep your operations running smoothly and efficiently.',
				},
				{
					image:
						window.ackShopifyFileUrl("Concierge_Icon_3_e158bd5d-0b1b-4c68-b2b7-dd942af2cda9.png"),
					title: 'On-Demand Expert Assistance',
					description:
						'⁠Get instant help when you need it most. Schedule live video calls with our multilingual team of specialists for real-time guidance. Overcome challenges quickly with tailored dental 3D printing support at your fingertips.',
				},
				{
					image:
						window.ackShopifyFileUrl("Concierge_Icon_2_d1075b33-366c-4e86-99d9-c6e2c37927b9.png"),
					title: 'Exclusive learning resources',
					description:
						'⁠Elevate your skills with our comprehensive training program. Access one-on-one sessions and custom workflow guides designed for your specific needs. Transform your capabilities and stay ahead in dental 3D printing technology.',
				},
			],
			ackurettaConciergeAmerican: {
				title: 'Concierge Service',
				subtitle:
					'Unlock a world of premium support and resources designed to accelerate your success in dental 3D printing.',
				description: 'Your Concierge Service Onboarding Kit Includes:',
				image:
					window.ackShopifyFileUrl("Concierge_Photo_Americas_LATAM_517b149e-03b9-4dd8-89a7-85fea4ede39a.jpg"),
				items: [
					'An official Concierge Service Certificate.',
					'A collection of ready to use 3D printing designs.',
					'Exclusive access to comprehensive training and learning resources, along with priority support available on-demand.',
				],
				additionalInfo:
					'Enjoy worry-free operation with our product exchange program. <b>Available in the United States, Canada, Puerto Rico, Australia, New Zealand and India</b> for the duration of your warranty.',
				termsLink: 'https://go.ackuretta.com/concierge-service/terms-and-conditions',
			},
			ackurettaConciergeAustralia: {
				title: 'Concierge Service',
				subtitle:
					'Unlock a world of premium support and resources designed to accelerate your success in dental 3D printing.',
				description: 'Your Concierge Service Onboarding Kit Includes:',
				image:
					window.ackShopifyFileUrl("Concierge_Photo_Americas_LATAM_517b149e-03b9-4dd8-89a7-85fea4ede39a.jpg"),
				items: [
					'An official Concierge Service Certificate.',
					'A collection of ready to use 3D printing designs.',
					'Exclusive access to comprehensive training and learning resources, along with priority support available on-demand.',
				],
				additionalInfo:
					'Enjoy worry-free operation with our product exchange program. <b>Available in the United States, Canada, Puerto Rico, Australia, New Zealand and India</b> for the duration of your warranty.',
				termsLink: 'https://go.ackuretta.com/concierge-service/terms-and-conditions',
			},
			ackurettaConciergeLatam: {
				title: 'Concierge Service',
				subtitle:
					'Unlock a world of premium support and resources designed to accelerate your success in dental 3D printing.',
				description: 'Your Concierge Service Onboarding Kit Includes:',
				image:
					window.ackShopifyFileUrl("Concierge_Photo_Americas_LATAM_517b149e-03b9-4dd8-89a7-85fea4ede39a.jpg"),
				items: [
					'An official Concierge Service Certificate.',
					'A collection of ready to use 3D printing designs.',
					'Exclusive access to comprehensive training and learning resources, along with priority support available on-demand.',
				],
				termsLink: 'https://go.ackuretta.com/concierge-service/terms-and-conditions',
			},
			ackurettaConciergeEurope: {
				title: 'Concierge Service',
				subtitle:
					'Unlock a world of premium support and resources designed to accelerate your success in dental 3D printing.',
				description: 'Your Concierge Service Onboarding Kit Includes:',
				image:
					window.ackShopifyFileUrl("Concierge_Photo_Americas_LATAM_517b149e-03b9-4dd8-89a7-85fea4ede39a.jpg"),
				items: [
					'An official Concierge Service Certificate.',
					'A collection of ready to use 3D printing designs.',
					'Exclusive access to comprehensive training and learning resources, along with priority support available on-demand.',
				],
				additionalInfo:
					'Enjoy worry-free operation with our product exchange program. <b>Available in the United States, Canada, Puerto Rico, Australia, New Zealand, India and Europe for the duration of your warranty.',
				termsLink: 'https://go.ackuretta.com/concierge-service/terms-and-conditions',
			},
			ackurettaConciergeWorld: {
				title: 'Concierge World',
				subtitle:
					'Unlock a world of premium support and resources designed to accelerate your success in dental 3D printing.',
				description: 'Your Concierge Service Onboarding Kit Includes:',
				image:
					window.ackShopifyFileUrl("Concierge_Photo_World_0954091c-c17b-41af-a691-a7860b34756b.jpg"),
				items: [
					'An official Concierge Service Certificate.',
					'A collection of ready to use 3D printing designs.',
					'Exclusive access to comprehensive training and learning resources, along with priority support available on-demand.',
				],
				termsLink: 'https://go.ackuretta.com/concierge-world/terms-and-conditions',
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		...Vuex.mapActions('shop', ['addToCartFromProperties', 'getProductPrice']),

		productPrice() {
			this.getProductPrice({
				variantId: 'gid://shopify/ProductVariant/40190862983271',
				sellingPlanId: null,
			})
				.then((priceInfo) => {
					if (priceInfo) {
						this.conciergeServicePrice = parseFloat(priceInfo.amount);
					} else {
						this.conciergeServicePrice = 'Price not available';
					}
				})
				.catch((error) => {
					console.error('Error fetching concierge price:', error);
					this.conciergeServicePrice = 'Price not available';
				});
		},

		// TODO: For now, we don't support the user to add Concierge Service to the cart directly
		onAddToCartCSClick() {
			appLog.log('onAddToCartCSClick', LOG_TYPE.debug);

			this.addToCartFromProperties({
				productId: 'gid://shopify/Product/6779701428327',
				variantId: 'gid://shopify/ProductVariant/40190851186791',
				sellingPlanId: null,
			});
		},

		onAddToCartCWClick() {
			appLog.log('onAddToCartCWClick', LOG_TYPE.debug);

			this.addToCartFromProperties({
				productId: 'gid://shopify/Product/6779706933351',
				variantId: 'gid://shopify/ProductVariant/40190862983271',
				sellingPlanId: null,
			});
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
